<template>
  <div class="shipping_bar" :id="id" v-if="ready && this.tiers && this.tiers.length">
    <!--Hey!<button @click="log">How am I?</button>-->
    <shipping_progress_bar :id="id" :cart-total="useOriginalTotal ? originalCartTotal : cartTotal" :current-tier="currentTier" :prev-tier="highestAchievedTier" :shown="shown" :delay="delay" :icon-type="iconType">
    </shipping_progress_bar>
  </div>
</template>

<script>

  /** Returns null when setting is blank or whitespace-only: caller must use full-cart original total, not tag filtering. */
  function parseSpendSaveEligibleTags(csv) {
    if (csv == null || typeof csv !== 'string') {
      return null;
    }
    const trimmed = csv.trim();
    if (!trimmed) {
      return null;
    }
    const tags = trimmed.split(',').map((t) => t.trim()).filter(Boolean);
    return tags.length ? tags : null;
  }

  export default {
    name: 'shipping_bar',
    props: ['id', 'tiers', 'cartTotal', 'useOriginalTotal', 'shown', 'delay', 'ready', 'iconType', 'cartItemsSignature'],
    computed: {
      convertedTiers: function() {
        // Only convert tiers for birthday promos (check if ID contains 'Birthday')
        const isBirthdayPromo = this.id && this.id.includes('Birthday');
        
        if (isBirthdayPromo && window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) {
          const rate = parseFloat(window.Shopify.currency.rate);
          return this.tiers.map(tier => ({
            ...tier,
            min_spend: Math.ceil(tier.min_spend * rate)
          }));
        }
        return this.tiers;
      },
      /** If eligible-tags setting has entries: sum original_line_price for matching lines. If blank: null (use original_total_price). */
      eligibleSpendTotalCents: function() {
        void this.cartItemsSignature;
        void this.cartTotal;
        if (!this.useOriginalTotal) {
          return null;
        }
        const csv = window.config && window.config.spendSaveEligibleTagsCsv;
        const tagList = parseSpendSaveEligibleTags(csv);
        if (!tagList) {
          return null;
        }
        const cart = window.theme && window.theme.cart;
        if (!cart || !cart.items) {
          return 0;
        }
        const tagSet = new Set(tagList);
        let sum = 0;
        for (let i = 0; i < cart.items.length; i++) {
          const item = cart.items[i];
          const itemTags = item.tags || [];
          let matches = false;
          for (let j = 0; j < itemTags.length; j++) {
            if (tagSet.has(itemTags[j])) {
              matches = true;
              break;
            }
          }
          if (!matches) {
            continue;
          }
          const line = item.original_line_price;
          if (typeof line === 'number' && !Number.isNaN(line)) {
            sum += line;
          }
        }
        return sum;
      },
      originalCartTotal: function() {
        if (!this.useOriginalTotal) {
          return this.cartTotal;
        }
        const eligibleOnlyTotal = this.eligibleSpendTotalCents;
        if (eligibleOnlyTotal !== null) {
          return eligibleOnlyTotal;
        }
        if (window.theme && window.theme.cart && window.theme.cart.original_total_price) {
          return window.theme.cart.original_total_price;
        }
        return this.cartTotal;
      },
      currentTier: function() {
        // Use original cart total for tier calculation only if useOriginalTotal is true (birthday promotion)
        const cartTotalToUse = this.useOriginalTotal ? this.originalCartTotal : this.cartTotal;

        // because .sort mutates in place, we sort a shallow copy created with [...]
        const tiersAscending = [ ...this.convertedTiers ].sort((a, b) => { return a.min_spend - b.min_spend });
        // Return the current tier. This will be the tier with the lowest total that we do not qualify for, or if there are no tiers we do not qualify for, the tier with the highest total.
        return tiersAscending.find(tier => (tier.min_spend * 100) > cartTotalToUse) || tiersAscending[tiersAscending.length - 1];
      },
      highestAchievedTier: function() {
        // Use original cart total for tier calculation only if useOriginalTotal is true (birthday promotion)
        const cartTotalToUse = this.useOriginalTotal ? this.originalCartTotal : this.cartTotal;

        const tiersAscending = [ ...this.convertedTiers ].sort((a, b) => { return a.min_spend - b.min_spend });
        const achievedTiers = tiersAscending.filter(tier => (tier.min_spend * 100) <= cartTotalToUse);
        return achievedTiers[achievedTiers.length - 1];
      }
    },
    methods: {  
      log: function(e) {
        console.log(this);
        console.log(this.tiers);
        console.log(this.cartTotal);
        console.log(this.currentTier);
      },
    },
  }
</script>